<template>
  <div v-wechat-title="$route.meta.title">
    <common-header></common-header>
    <common-nav :locale="locale"></common-nav>
    <common-banner title="new"></common-banner>
    <common-title :cn="$t('txt.sjyy')"></common-title>
    <u-animate-container class="company_partner">
      <div class="container">
        <u-animate
          name="slideInLeft"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
          v-if="!isMobile"
        >
          <div class="latest-news">
            <div class="latest-news-txt" @click="handleClick(list[0].newsId)">
              <p class="time">{{ list[0].publishTime }}</p>
              <p class="title">{{ list[0].title }}</p>
              <p class="desc">{{ list[0].desc }}</p>
            </div>
            <img
              class="latest-news-img"
              :src="list[0].image"
              @click="handleClick(list[0].newsId)"
            />
          </div>
        </u-animate>

        <div class="list">
          <u-animate
            v-for="(it, index) in isMobile ? list : list.slice(1, list.length)"
            :key="index"
            class="item"
            name="slideInLeft"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <div class="item-img">
              <img
                class="item-img-url"
                :src="it.image"
                @click="handleClick(it.newsId)"
              />
            </div>
            <div class="item-txt" @click="handleClick(it.newsId)">
              <p class="title">{{ it.title }}</p>
              <p class="time">{{ it.publishTime }}</p>
            </div>
          </u-animate>
        </div>
        <div class="pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="pageParams.limit"
            @current-change="handleChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </u-animate-container>
    <common-footer :locale="locale"></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonBanner from "./components/Common/Banner";
export default {
  components: {
    UAnimateContainer,
    UAnimate,
    CommonNav,
    CommonHeader,
    CommonFooter,
    CommonBanner
  },
  created() {
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
    this.getData();
    // this.$route.meta.title = '动态修改的首页'
  },
  data() {
    return {
      locale: "zh-cn",
      list: [],
      pageParams: { page: 1, limit: 10 },
      total: 0
    };
  },
  computed: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  },
  methods: {
    getData() {
      let lang2 = this.locale ? this.locale : "zh-cn";
      this.$axios
        .post(
          "/api/news/list",
          { ...this.pageParams },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log("首页数据:", res);
          if (res.data.errorCode === 0) {
            this.list = res.data.data.data;
            this.total = res.data.data.total;
          } else {
            this.$alert(res.data.errorMsg);
          }
          // console.log(this.bannerData)
          // console.log(this.productData)
        })
        .catch(res => {
          console.log(res);
        });
    },
    handleClick(id) {
      this.$router.push({
        path: "/newsDetail/" + id
      });
    },
    handleChange(val) {
      this.pageParams.page = val;
      this.getData();
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 1200px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  padding: 60px 0;
}
.company_profile {
  position: relative;
  .bg_left {
    background: #f2f2f2;
    width: 55%;
    height: 460px;
    position: absolute;
    top: 100px;
    left: 0;
    z-index: -1;
  }
  .title_en {
    color: #fd8204;
    font-size: 0.15rem;
  }
  .title_cn {
    color: #333;
    font-size: 0.55rem;
    margin-top: 10px;
  }
  .title_line {
    width: 80px;
    background: #ff5e17;
    margin: 45px 0;
    height: 2px;
  }
  .profile_content {
    width: 50%;
    height: auto;
    font-size: 0.17rem;
    color: #333;
    line-height: 1.8;
  }
  img.map {
    margin: 60px auto;
    display: block;
  }
}
.company_partner {
  .top {
    box-sizing: border-box;
    display: block;
    padding: 0 80px;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.16rem;
    color: #fff;
    height: 50px;
    line-height: 2.2;
    text-align: center;
    margin-bottom: 60px;
  }
  .latest-news {
    display: grid;
    height: 600px;
    margin-bottom: 30px;
    grid-template-columns: 1.5fr 2fr;
    cursor: pointer;
    &:hover {
      box-shadow: 0 5px 10px 4px #d6d3d3bf;
      border-color: #666;
    }
    &-txt {
      overflow: hidden;
      .title {
        font-size: 0.48rem;
        color: #ff8300;
        font-size: bold;
        margin-bottom: 0.5rem;
      }
      .time {
        margin-bottom: 0.5rem;
        margin-top: 30px;
        font-size: 0.2rem;
        color: #000;
      }
      .desc {
        width: 100%;
        color: #808080;
        font-size: 0.18rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
      }
    }
    &-img {
      width: 100%;
      height: 600px;
    }
  }
  .list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 30px;
    grid-row-gap: 45px;
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    .item {
      display: flex;
      display: -ms-flexbox;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 400px;
      cursor: pointer;
      border-bottom: 1px solid #d9d2d2;
      &:hover {
        box-shadow: 0 5px 47px 4px #d6d3d3bf;
        border-color: #666;
      }
      &-img {
        width: 100%;
        height: 270px;
        vertical-align: middle;
        &-url {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &-txt {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 0.2rem;
        height: calc(100% - 270px);
        padding: 25px 15px 15px;
        box-sizing: border-box;
        .title {
          color: #000;
        }
        .time {
          color: #ccc;
        }
      }
    }
  }
  .pagination {
    width: 100%;
    display: flex;
    margin-top: 1rem;
    justify-content: center;
    align-items: center;
  }
}
.efficient_collaboration {
  color: #fff;
  background: #fd8103;
  box-sizing: border-box;
  .container {
    overflow: inherit;
    .ec_en {
      font-size: 0.15rem;
      text-align: center;
    }
    .ec_cn {
      font-size: 0.45rem;
      text-align: center;
      margin-top: 10px;
    }
    .ec_line {
      background: #fff;
      height: 2px;
      width: 80px;
      display: block;
      margin: 45px auto;
    }
    .ec_p {
      font-size: 0.17rem;
      text-align: center;
      line-height: 2;
    }
    .ec_xlsx {
      width: 1140px;
      margin: 45px auto;
      display: flex;
      display: -ms-flexbox;
      justify-content: center;
      color: #333;
      font-size: 0.26rem;
      height: 140px;
      line-height: 125px;
      position: relative;
      font-weight: bold;
      span {
        position: relative;
        z-index: 999;
        &.last {
          color: #dd5629;
          margin-left: 5px;
        }
      }
      img {
        position: absolute;
        width: 300px;
        right: -160px;
        top: -286px;
      }
    }
    .ec_three {
      display: flex;
      display: -ms-flexbox;
      box-sizing: border-box;
      border: 2px solid #fff;
      color: #fff;
      width: 800px;
      margin: 0 auto 60px;
      .item {
        width: 33%;
        display: flex;
        display: -ms-flexbox;
        align-items: center;
        justify-content: center;
        flex: 1;
        -ms-flex: 1;
        flex-direction: row;
        background: #fe9528;
        height: 180px;
        img {
          width: 100px;
          height: auto;
        }
        .item_txt {
          font-size: 0.25rem;
          margin-left: 20px;
        }
        &:nth-of-type(2) {
          border-left: 2px solid #fff;
          border-right: 2px solid #fff;
        }
        &:hover {
          background: #fd8f1e;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .container {
    width: 100%;
    padding: 30px 0;
    box-sizing: border-box;
  }
  .company_profile {
    .bg_left {
      background: none;
    }
    .container {
      padding: 15px 30px;
    }
    .title_cn {
      font-size: 1.5rem;
      text-align: center;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .title_en {
      font-size: 0.5rem;
      text-align: center;
    }
    .title_line {
      margin: 15px 0;
      display: none;
    }
    .profile_content {
      width: 100%;
      font-size: 0.7rem;
    }
    img.map {
      width: 100%;
      margin: 15px auto;
    }
  }
  .company_partner {
    .top {
      width: 90%;
      padding: 0 30px;
      height: 1.2rem;
    }
    .list {
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      display: block;
      .item {
        width: 100%;
        height: 300px;
        margin-bottom: 30px;
        box-shadow: 0 5px 47px 4px #d6d3d3bf;
        &:hover {
          border-color: #666;
        }
        &-img {
          width: 100%;
          height: 200px;
        }
        &-txt {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          font-size: 0.2rem;
          height: calc(100% - 200px);
          padding: 25px 15px 15px;
          box-sizing: border-box;
          .title {
            color: #000;
          }
          .time {
            color: #ccc;
          }
        }
      }
    }
  }
  .efficient_collaboration {
    .container {
      .ec_en {
        font-size: 0.5rem;
      }
      .ec_cn {
        font-size: 1rem;
        font-weight: bold;
      }
      .ec_line {
        margin: 15px auto;
      }
      .ec_p {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        font-size: 0.7rem;
      }
      .ec_xlsx {
        width: 95%;
        margin: 15px auto;
        font-size: 0.6rem;
        height: 5rem;
        line-height: 4.6rem;
        img {
          display: none;
        }
      }
      .ec_three {
        width: 100%;
        margin: 0 auto 15px;
        box-sizing: border-box;
        padding: 0 15px;
        border: 0;
        .item {
          flex-direction: column;
          height: 120px;
          border: 1px solid #fff;
          &:nth-of-type(2) {
            border-left: 0;
            border-right: 0;
          }
          .item_img {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 80px;
            height: 80px;
            img {
              width: 45px;
            }
          }
          .item_txt {
            font-size: 0.8rem;
            margin: 0.2rem auto 0.5rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new.vue